import { render, staticRenderFns } from "./IndustryProfile.vue?vue&type=template&id=aa35ec4a&scoped=true"
import script from "./IndustryProfile.vue?vue&type=script&lang=js"
export * from "./IndustryProfile.vue?vue&type=script&lang=js"
import style0 from "./IndustryProfile.vue?vue&type=style&index=0&id=aa35ec4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35ec4a",
  null
  
)

export default component.exports